import { ICatalogue } from "../../apis/useGetCatalogueData/types";
import { useDuplicationCheck } from "../../common/hooks/useDuplicationCheck";
import { Nullable } from "../../common/types/types";
import { useCatalogueContext } from "../../contexts/CatalogueContext/CatalogueContext";
import { ICatalogueContext } from "../../contexts/CatalogueContext/types";
import { useUrlParams } from "../../router/hooks";
import { PAGE_PARAM } from "../constants";

const getSelectedItem =
	(bmi: number) =>
	({ products }: ICatalogueContext) => {
		return products?.find(({ brand_menu_item_id }) => brand_menu_item_id === bmi) ?? null;
	};

const checkIsSameItem = (newitem?: Nullable<ICatalogue>, olditem?: Nullable<ICatalogue>) => {
	if (newitem === olditem) return true;
	if (newitem?.id !== olditem?.id) return false;

	return true;
};

export const useProductDetailPage = () => {
	const {
		brand_menu_item_id = null,
		mode = PAGE_PARAM.NEW,
		cart_item_index = null,
	} = useUrlParams();

	const { state: pdpitem } = useCatalogueContext(getSelectedItem(Number(brand_menu_item_id)));

	const item = useDuplicationCheck(pdpitem, checkIsSameItem);

	return {
		item,
		mode,
		brand_menu_item_id,
		cart_item_index: cart_item_index ? Number(cart_item_index) : null,
	};
};
